import React, { forwardRef, useState } from "react";
import SearchLocationInput from "../../components/SearchLocationInput";
import MapComponent from "../../components/MapComponent";

const LocationModal = forwardRef(({ show, close, selectedLocation, setSelectedLocation, onSaveLocation }, ref) => {
  const [query, setQuery] = useState("");
  const [addressInfo, setAddressInfo] = useState({
    address: "",
    city: "",
    state: "",
    postalCode: "",
    country: "",
  });

  const handleAddressSelect = (latLng, addressDetails) => {
    setSelectedLocation(latLng);
    setAddressInfo(addressDetails);
    setQuery(addressDetails.address); // Update input field with selected location
  };

  const reverseGeocode = async (latLng) => {
    const geocoder = new window.google.maps.Geocoder();
    geocoder.geocode({ location: latLng }, (results, status) => {
      if (status === "OK" && results[0]) {
        const addressDetails = {
          address: results[0].formatted_address,
          city: results[0].address_components.find((c) => c.types.includes("locality"))?.long_name || "",
          state: results[0].address_components.find((c) => c.types.includes("administrative_area_level_1"))?.long_name || "",
          postalCode: results[0].address_components.find((c) => c.types.includes("postal_code"))?.long_name || "",
          country: results[0].address_components.find((c) => c.types.includes("country"))?.long_name || "",
        };
        setAddressInfo(addressDetails);
        setQuery(addressDetails.address); // Update input field with dragged location
        setSelectedLocation(latLng);
      }
    });
  };

  const handleSave = () => {
    onSaveLocation(addressInfo);
    close(); // Close the modal after saving
  };

  return (
    <>
      {show && <div className="modal-overlay" />}
      <div
        className={`modal fade ${show ? "show" : ""}`}
        tabIndex="-1"
        aria-labelledby="locationModalLabel"
        aria-hidden={!show}
        style={{ display: show ? "block" : "none" }}
      >
        <div className="modal-dialog modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="locationModalLabel">
                Choose Location
              </h5>
              <button type="button" className="btn-close" onClick={close}>
                x
              </button>
            </div>
            <div className="modal-body">
              <SearchLocationInput
                setSelectedLocation={handleAddressSelect}
                query={query}
                setQuery={setQuery}
              />
              <MapComponent
                selectedLocation={selectedLocation}
                setSelectedLocation={(latLng) => reverseGeocode(latLng)}
                reverseGeocode={reverseGeocode}
              />
            </div>
            <div className="modal-footer">
              <button type="button" className="btn btn-secondary" onClick={close}>
                Close
              </button>
              <button type="button" className="btn btn-primary" onClick={handleSave}>
                Save Location
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
});

export default LocationModal;
